<template>
  <div>
    <ylNewsMobile
      v-if="isMobileScreen"
      v-bind="$attrs"
       />
    <ylNewsPC
      v-else
      v-bind="$attrs"
       />
  </div>
</template>
<script>
export default {
  name: "ylHomeNews",
  computed: {
    screenWidth() {
      return this.$store.getters.screenWidth;
    },
    screenHeight() {
      return this.$store.getters.screenHeight;
    },
    isMobileScreen() {
      return this.$store.getters.isMobileScreen;
    },
  },
  components: {
    ylNewsMobile: () => import("./components/mobile.vue"),
    ylNewsPC: () => import("./components/pc.vue"),
  },
};
</script>